import React from 'react'

import config from '../config'

//materia-ui
import { Divider, Grid, Typography } from '@mui/material'

export default function Footer() {
  return (
    <>
      <Divider />
      <Grid container style={{ marginTop: '20px' }}>
        <Grid size={1} />
        <Grid size={5}>
          <Typography variant="body2" color="textSecondary" align="left">
            Copyright © 2025, Summa Labs.
          </Typography>
        </Grid>
        <Grid size={5}>
          <Typography variant="body2" color="textSecondary" align="right">
            {config.env !== 'production' ? config.env.toUpperCase() : ''}{' '}
            {config.versionWeb} / {config.versionApi}
          </Typography>
        </Grid>
        <Grid size={1} />
      </Grid>
    </>
  );
}
